<template>
  <div class="empty-lists">
    <img src="~@/assets/images/empty-lists-image.svg" alt="" />
    <h2>{{ title }}</h2>
    <p>{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: "EmptyLists",

  props: {
    title: String,
    text: String
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/app";

.empty-lists {
  h2 {
    color: $grey-dark-custom;
    margin: 29px 0 15px;
    font-size: 20px;
    line-height: 22px;
  }

  p {
    max-width: 210px;
    margin: 0 auto;
    text-align: center;
    color: $grey-dark-custom;
    font-size: 14px;
    line-height: 22px;
  }
  @media screen and (max-width: 768px) {
  }
}
</style>
